import { Box, Typography } from "@material-ui/core";
import {
  required,
  TextInput,
  FormDataConsumer,
  ArrayInput,
  SimpleFormIterator,
  Button,
  DateInput,
  NumberInput,
} from "react-admin";
import * as S from "./CardCampaign.styles";

const validateRequired = required();
const fieldStyle = { width: "256px", minWidth: "256px" };
const validateStartEndDate = (data) => () => {
  return new Date(data.start) > new Date(data.end)
  ? 'A data inicial deve ser antes da data final'
  : undefined
}

const validateDates = (data) => [required(), validateStartEndDate(data)]

const CardCampaign = () => {

  return (
    <>
      <S.Title>
        <Typography variant="h6">Campanha</Typography>
      </S.Title>
      <ArrayInput label={false} source="campaignList" defaultValue={[{}]}>
        <SimpleFormIterator
          getItemLabel={() => false}
          disabled
          disableRemove
          disableReordering
          addButton={<Button>+ Adicionar Nova Campanha</Button>}
        >
          <FormDataConsumer>
            {({ getSource, scopedFormData }) => {
              return (
                <S.Card>
                  <TextInput
                    source={getSource("name")}
                    label="Nome"
                    validate={validateRequired}
                    style={fieldStyle}
                  />
                  <Box>
                    <Typography variant="p"> Duração *: </Typography>
                    <DateInput
                      label="De"
                      source={getSource("start")}
                      validate={validateDates(scopedFormData)}
                    />
                    <DateInput
                      label="Até"
                      source={getSource("end")}
                      validate={validateDates(scopedFormData)}
                    />
                  </Box>
                  <Box>
                    <NumberInput
                      source={getSource("doctorQuantity")}
                      label="Qtd de médicos"
                      validate={validateRequired}
                      style={fieldStyle}
                    />
                    <NumberInput
                      source={getSource("shipmentQuantity")}
                      label="Qtd de Envios"
                      validate={validateRequired}
                      style={fieldStyle}
                    />
                  </Box>
                </S.Card>
              );
            }}
          </FormDataConsumer>
        </SimpleFormIterator>
      </ArrayInput>
    </>
  );
};

export default CardCampaign;
